/**
 * @fileoverview Utils Module Barrel Exports
 * @description Centralized exports for utility functions
 * @module utils
 */

export { getProfileInitials } from './profile-utils';
export { getApiErrorMessage } from './apiError';
export { extractAllElements } from './extractElements';
